module.exports = __webpack_public_path__ + "datahub/img/晴转多云.371201f4.png";